export default __webpack_public_path__ + "static/media/logo192.4b5db332.png";